"use client";
import { fileMatchesAccept as e } from "../../../utils/utils.mjs";
import { useCallback as t, useState as n } from "react";
//#region src/components/atoms/FileInput/useFileInput.ts
function r(e) {
	return e == null ? [] : Array.isArray(e) ? e : [e];
}
function i(e) {
	return e.length > 0;
}
var a = (a, o = {}) => {
	let { accept: s, maxSizeBytes: c, multiple: l, maxFiles: u, onFileSelected: d, error: f, onError: p, value: m } = o, h = m !== void 0, [g, _] = n([]), [v, y] = n(!1), [b, x] = n(null), [S, C] = n(null), w = r(m), T = h ? w : g, E = T.length, D = l ? i(T) ? T : null : T[0] ?? null, O = f ?? b, k = v ? "loading" : O ? "error" : i(T) ? "success" : "default", A = t((e, t, n) => {
		let r = p?.({
			type: e,
			file: t,
			defaultMessage: n
		});
		return typeof r == "string" ? r : n;
	}, [p]), j = t((t) => {
		if (s?.length && !e(t, s)) {
			let e = `Unsupported file type. Please upload a ${s.join(", ")} file.`;
			return C("unsupported_type"), x(A("unsupported_type", t, e)), "unsupported_type";
		}
		if (c && t.size > c) {
			let e = `File exceeds the ${Math.round(c / 1024 / 1024)} MB limit. Please upload a smaller file.`;
			return C("file_too_large"), x(A("file_too_large", t, e)), "file_too_large";
		}
		return null;
	}, [
		s,
		c,
		A
	]), M = t(() => {
		_([]), y(!1), x(null), C(null), a.current && (a.current.value = "");
	}, [a]), N = t(() => {
		a.current?.click();
	}, [a]), P = t(async (e) => {
		if (j(e)) h || _([]);
		else if (h || _([e]), x(null), C(null), d) {
			y(!0);
			try {
				await d(e);
			} catch (t) {
				let n = t instanceof Error ? t.message : "An error occurred processing the file";
				C("processing_error"), x(A("processing_error", e, n));
			} finally {
				y(!1);
			}
		}
	}, [
		j,
		d,
		A,
		h
	]), F = t(async (e) => {
		if (u && E + e.length > u) {
			C("too_many_files"), x(A("too_many_files", e[0], "Maximum files added"));
			return;
		}
		let t = [], n = !1;
		for (let r of e) j(r) ? n = !0 : t.push(r);
		if (n || (x(null), C(null)), h || _((e) => [...e, ...t]), d && t.length !== 0) {
			y(!0);
			try {
				await d(t);
			} catch (e) {
				let n = e instanceof Error ? e.message : "An error occurred processing the files";
				C("processing_error"), x(A("processing_error", t[0], n));
			} finally {
				y(!1);
			}
		}
	}, [
		j,
		u,
		E,
		d,
		A,
		h
	]);
	return {
		state: k,
		file: D,
		error: O,
		errorType: S,
		handleChange: t(async (e) => {
			let t = e.target.files;
			!t || t.length === 0 ? l || M() : l ? await F(Array.from(t)) : await P(t[0]);
		}, [
			l,
			P,
			F,
			M
		]),
		handleDrop: t(async (e) => {
			e.length === 0 ? l || M() : l ? await F(Array.from(e)) : await P(e[0]);
		}, [
			l,
			P,
			F,
			M
		]),
		openFilePicker: N,
		reset: M,
		removeFile: t((e) => {
			l && (_((t) => {
				let n = t.filter((t, n) => n !== e);
				return n.length === 0 && M(), n;
			}), x(null), C(null));
		}, [l, M])
	};
};
//#endregion
export { a as useFileInput };
